import type { BaseRouteType, BaseMethodType } from '../types.ts'
import { z } from "zod";
export const tagsGetMunicipalities = z.any()
export type TagsGetMunicipalities = z.infer<typeof tagsGetMunicipalities>

export const responseGetMunicipalities = z.object({ "payload": z.array(z.object({ "id": z.string(), "name": z.string(), "ico": z.string(), "plan": z.enum(["TRIAL","STANDARD","VIP"]).default("TRIAL"), "planStartedAt": z.string(), "planEndsAt": z.string(), "isSMSCrMember": z.boolean().optional(), "smsCrServicesGDPRSale": z.boolean().optional(), "createdAt": z.string().optional(), "updatedAt": z.string().optional(), "image": z.string().optional() })).optional(), "errors": z.any(), "message": z.string().optional() })
export type ResponseGetMunicipalities = z.infer<typeof responseGetMunicipalities>

interface IGetMunicipalities extends BaseMethodType {
  tags: TagsGetMunicipalities,
  response: ResponseGetMunicipalities
}
export const URL = '/municipalities'
export const validation = {
  get: {
    tags: tagsGetMunicipalities,
    response: responseGetMunicipalities
  }
}
export interface Municipalities extends BaseRouteType {
  get: IGetMunicipalities
}